"use client";

import dynamic from "next/dynamic";
import { Grid, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/grid";
import styles from "@/assets/css/pages/font.module.css";
import "swiper/css/pagination";
import { useEffect } from "react";
import { useAppSelector } from "@/lib/store";
import { createItemListPayload } from "@/lib/utils/helpers/plp";
import { viewItemListAnalytics } from "@/lib/gtm";
import { formatProductGA4, mutateProductInfo } from "@/lib/utils/functions";

const Swiper = dynamic(() => import("@/components/common/shared/Slider"));
const Card = dynamic(() => import("@/components/common/card/ProductsCard"));

const TopProductListing = ({
  title = "",
  products,
  bestSellerImg,
  recommendedImg,
  isCarParts = false,
}) => {
  const { appInitailized } = useAppSelector((state) => state.uiState);

  useEffect(() => {
    if (!appInitailized) return;
    if (products.length > 0) {
      const formattedProducts = formatProductGA4(
        products
          .map((p) => mutateProductInfo(p))
          .map((el) => ({ ...el, quantity: 1 })),
      );
      viewItemListAnalytics(
        createItemListPayload(formattedProducts, "Brands Products", true),
      );
    }
  }, [appInitailized, products]);

  const sliderConfig = {
    breakpoints: {
      0: {
        spaceBetween: 16,
        slidesPerView: 2,
        loop: false,
        freeMode: true,
        slidesPerGroup: 2,
        grid: { rows: 1, fill: "row" },
      },
      520: {
        spaceBetween: 16,
        slidesPerView: 3,
        grid: { rows: 1, fill: "row" },
      },
      1140: {
        spaceBetween: 24,
        slidesPerView: 4,
        grid: { rows: 4, fill: "row" },
      },
    },
    modules: [Grid, Pagination],
    pagination: {
      clickable: true,
    },
  };
  const slides = products.map((p, i) => ({
    content: (
      <Card
        product={p}
        isCarParts={isCarParts}
        loop_index={i}
        item_list="Featured Products"
        bestSellerImg={bestSellerImg}
        recommendedImg={recommendedImg}
      />
    ),
  }));

  return (
    <section className="w-12/12 pb-6 sm:pb-80 bg-tertiary-white category-section xs:min-h-max min-h-[350px] brand-listing-slider">
      <div className="container xs:mb-24 mb-12">
        <div className="row">
          <div className="col w-12/12">
            <div className="flex justify-between items-baseline xs:items-end">
              <div className="flex flex-col">
                <p className={`${styles.homeHeading} `}>Top {title} Products</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container xs:pr-[0.75rem] lg:pr-5">
        <div className="row xs:mr-[-0.75rem]">
          <div className="col w-12/12 xs:pr-[0.75rem]">
            <Swiper
              slides={slides}
              config={sliderConfig}
              className="deals-product-slider"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopProductListing;
